export const LEAD_ENDPOINT = 'https://formsubmit.co/ajax/info@startawebb.se';

export function parseContact(value) {
  const contact = String(value || '').trim();
  if (contact.length > 160) return null;
  if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(contact)) return { email: contact, telefon: '' };
  const phone = contact.replace(/[\s().-]/g, '');
  if (/^\+?\d{7,15}$/.test(phone)) return { email: '', telefon: contact };
  return null;
}

export async function submitLead(payload, { signal, timeoutMs = 20000 } = {}) {
  const controller = new AbortController();
  const onAbort = () => controller.abort();
  if (signal?.aborted) controller.abort();
  signal?.addEventListener('abort', onAbort, { once: true });
  const timeout = setTimeout(() => controller.abort(), timeoutMs);
  try {
    const response = await fetch(LEAD_ENDPOINT, {
      method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      signal: controller.signal,
    });
    if (!response.ok) throw new Error('provider_http_error');
    const result = await response.json();
    if (result?.success !== true && result?.success !== 'true') throw new Error('provider_rejected');
    return result;
  } finally {
    clearTimeout(timeout);
    signal?.removeEventListener('abort', onAbort);
  }
}
